import AnalyticsEvents_V2 from '../analyticsGA4'
import { Labels, PortalProducts } from '../types/analytics.type'

import { MathEssentialsAnalyticsEvents } from './mathEssentialsAnalytics.types'

class MathEssentialsAnalytics extends AnalyticsEvents_V2 {
  public constructor() {
    super(PortalProducts.MATH_ESSENTIALS)
  }

  public logCheckAnswer(correct: boolean): void {
    this.logEvent({
      event: MathEssentialsAnalyticsEvents.CHECK_ANSWER,
      value: correct ? Labels.CORRECT : Labels.INCORRECT,
    })
  }

  public logNextQuestionNavigation(): void {
    this.logEvent({
      event: MathEssentialsAnalyticsEvents.NEXT_QUESTION_NAVIGATION,
      product: PortalProducts.NAVIGATION,
    })
  }

  public logQuizCompleted(correctPercentage: number): void {
    this.logEvent({
      event: MathEssentialsAnalyticsEvents.QUIZ_COMPLETED,
      value: correctPercentage,
    })
  }
}

export default new MathEssentialsAnalytics()
